import { render, staticRenderFns } from "./ProspectiveStudentList.vue?vue&type=template&id=5c47891e"
import script from "./ProspectiveStudentList.vue?vue&type=script&lang=js"
export * from "./ProspectiveStudentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports